import { useEffect, useState } from "react"
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2'
import { toast } from 'react-toastify';

export const useActions = ({
    //------------- Generales
    marvarApi, dispatch, user, onLogout, location, paramsURL, toggle, setDataModal,
    FetchData, Helpers,

    defaultData,

    //------------- Forms
    Forms,

    globalStates

}) => {

    const openModal = (_, title, compont, dataRequest) => {
        toggle(_, title, compont, dataRequest)
    }

    const closeModal = () => {
        toggle()
    }

    const handleClickFechtVehicleCredits = async (campo, identificador) => {
        const { fetchAllVehicleCredits: { setParamsToSearch, executeFetchAllVehicleCredits }, fetchAllCreditsPayments: { setCreditPayments } } = FetchData
        const { FormRequestGlobal: { onResetForm, setFormState } } = Forms

        setParamsToSearch({ campo: campo, identificador: identificador })
        onResetForm()
        setCreditPayments([])
        await executeFetchAllVehicleCredits()

        setFormState(prevState => ({
            ...prevState,
            [campo]: identificador.replace(/%/g, "")
        }))
    }

    const handleClickSearchPayments = async () => {
        const { fetchAllCreditsPayments: { setParamsToSearch, executeFetchAllCreditPayments } } = FetchData
        const { FormRequestGlobal: { formState, setFormState } } = Forms
        const { extractIdVehicle } = Helpers

        const { statusCode, statusMessage, idcredito } = extractIdVehicle(formState.identificador);

        if (!statusCode) {
            const messageCustom = {
                message: statusMessage,
                title: 'FAIL',
                rows: []
            }
            alertMessage(messageCustom)
            return
        } else {
            setFormState(prevState => ({
                ...prevState,
                'idcredito': idcredito
            }))
        }
        setParamsToSearch({ idcredito: idcredito })


        executeFetchAllCreditPayments()
    }

    const handleKeyDown = (event) => {
        const { fetchAllCreditsPayments: { setParamsToSearch, executeFetchAllCreditPayments } } = FetchData
        const { FormRequestGlobal: { formState, setFormState } } = Forms
        const { extractIdVehicle } = Helpers

        if (event.key === 'Enter') {
            event.preventDefault();
            const { statusCode, statusMessage, idcredito } = extractIdVehicle(formState.identificador);
            if (!statusCode) {
                const messageCustom = {
                    message: statusMessage,
                    title: 'FAIL',
                    rows: []
                }
                alertMessage(messageCustom)
                return
            } else {
                setFormState(prevState => ({
                    ...prevState,
                    'idcredito': idcredito
                }))
            }

            setParamsToSearch({ idcredito: idcredito })
            executeFetchAllCreditPayments()
        }
    };


    const handleClickShowModal = (_, title, compont, dataRequest, modalOpeningMode) => {

        let dias_atraso_temp
        const { calculateLateInterest } = Helpers

        const { 
            idcredito, 
            idpago, 
            dias_atraso, 
            dias_atraso_ultimo_pago, 
            cuota_pagar, 
            saldo_cuota_anterior, 
            mora, 
            total_abonado, 
            total_pagar, 
            saldo_cuota,
        } = dataRequest

        const { setModalOpeningMode } = globalStates

        const { fetchAllDeposits: { executeFetchAllDeposits } } = FetchData;

        const { FormRequestGlobal: { setFormState } } = Forms;

        setFormState(prevState => ({
            ...prevState,
            idcredito: idcredito ?? prevState.idcredito,
            idpago: idpago,
            cuota_pagar: cuota_pagar,
            saldo_cuota_anterior: saldo_cuota_anterior || 0,
            mora: mora,
            total_abonado: total_abonado || 0,
            total_pagar: total_pagar,
            total_restante: (total_pagar - (total_abonado || 0))
        }))

        if (compont === "deposits-table") executeFetchAllDeposits()

        setModalOpeningMode(modalOpeningMode)
        openModal(_, title, compont, dataRequest)
    }

    const handleClickCloseModal = () => {

        //HOOKS
        const { FormDeposit } = Forms
        const { onResetForm } = FormDeposit
        onResetForm()
        closeModal()
    }

    const handleChangeAmount = (event) => {

        //HOOKS
        const { FormDeposit } = Forms
        const { setFormState, formState } = FormDeposit
        const { deposito_tipo_cambio } = formState

        const { name, value } = event.target

        //Verificamos si tiene data
        const monto = value !== '' ? value : 0;
        const tipo_cambio = deposito_tipo_cambio !== '' ? deposito_tipo_cambio : 0;

        if (formState.deposito_moneda === 'DOLAR') {
            setFormState(prevState => ({
                ...prevState,
                [name]: value,
                deposito_quetzales: (monto * tipo_cambio),
                deposito_dolares: (monto),
            }))
        } else if (formState.deposito_moneda === 'QUETZAL') {
            setFormState(prevState => ({
                ...prevState,
                [name]: value,
                deposito_quetzales: (monto),
                deposito_dolares: (monto / tipo_cambio),
            }))
        } else {
            setFormState(prevState => ({
                ...prevState,
                [name]: value
            }))
        }
    }

    const handleChangeTypeCurrency = (event) => {

        //HOOKS
        const { FormDeposit } = Forms
        const { setFormState, formState } = FormDeposit
        const { deposito_monto, deposito_tipo_cambio } = formState

        const { name, value } = event.target

        //Verificamos si tiene data
        const monto = deposito_monto !== '' ? deposito_monto : 0;
        const tipo_cambio = deposito_tipo_cambio !== '' ? deposito_tipo_cambio : 0;

        if (value === 'DOLAR') {
            setFormState(prevState => ({
                ...prevState,
                [name]: value,
                deposito_quetzales: (monto * tipo_cambio),
                deposito_dolares: (monto),
            }))
        } else if (value === 'QUETZAL') {
            setFormState(prevState => ({
                ...prevState,
                [name]: value,
                deposito_quetzales: (monto),
                deposito_dolares: (monto / tipo_cambio),
            }))
        }
    }

    const handleChangeExchangeRate = (event) => {

        //HOOKS
        const { FormDeposit } = Forms
        const { setFormState, formState } = FormDeposit
        const { deposito_monto } = formState

        const { name, value } = event.target

        //Verificamos si tiene data
        const monto = deposito_monto !== '' ? deposito_monto : 0;
        const tipo_cambio = value !== '' ? value : 0;

        if (formState.deposito_moneda === 'DOLAR') {
            setFormState(prevState => ({
                ...prevState,
                [name]: value,
                deposito_quetzales: (monto * tipo_cambio),
                deposito_dolares: (monto),
            }))
        } else if (formState.deposito_moneda === 'QUETZAL') {
            setFormState(prevState => ({
                ...prevState,
                [name]: value,
                deposito_quetzales: (monto),
                deposito_dolares: (monto / tipo_cambio),
            }))
        } else {
            setFormState(prevState => ({
                ...prevState,
                [name]: value
            }))
        }
    }

    const handleClickDownloadImage = async (customFileName, openUrl) => {

        try {
            const response = await fetch(openUrl);
            const blob = await response.blob();

            // Crear un enlace temporal
            const enlaceTemporal = document.createElement('a');
            enlaceTemporal.href = window.URL.createObjectURL(blob);
            enlaceTemporal.download = customFileName; // Puedes cambiar el nombre del archivo
            document.body.appendChild(enlaceTemporal);

            // Simular clic en el enlace para iniciar la descarga
            enlaceTemporal.click();

            // Eliminar el enlace temporal
            document.body.removeChild(enlaceTemporal);

            toast.success('Se ha descargado la imagen');

        } catch (error) {
            console.error('Error al descargar la imagen', error);
        }

    }

    const onSubmitFormDeposits = async (e) => {

        e.preventDefault()

        const { FormDeposit, FormRequestGlobal } = Forms
        const { formState, onResetForm } = FormDeposit
        const formStateGlobal = FormRequestGlobal.formState

        const { fetchAllCreditsPayments: { executeFetchAllCreditPayments } } = FetchData

        const { getCurrentDate, extractIdVehicle } = Helpers

        const { idcredito } = extractIdVehicle(FormRequestGlobal.identificador)

        if (formState.movimiento_tipo === 'EFECTIVO') {

            const _data = {
                idpago: formStateGlobal.idpago,
                idcredito: idcredito,
                deposito_usuario: user.username,
                fecha_creo: getCurrentDate(),
                deposito_fecha: formState.deposito_fecha,
                movimiento_tipo: formState.movimiento_tipo,
                deposito_monto: parseFloat(formState.deposito_monto),
                deposito_moneda: formState.deposito_moneda,
                deposito_tipo_cambio: parseFloat(formState.deposito_tipo_cambio),
                deposito_quetzal: parseFloat(formState.deposito_quetzales),
                deposito_dolares: parseFloat(formState.deposito_dolares),
                idcaja: formState.idcaja,
                saldo_anterior: formStateGlobal.saldo_cuota_anterior,
                deposito_observaciones: formState.deposito_observaciones,
                usuario_creo: user.username,
                fecha_creo: getCurrentDate()
            }

            console.log(_data);

            await marvarApi.post(`/vehicle/mgmt-payments/create-deposit-cash`, _data)
                .then(({ data }) => {

                    alertMessage(data)

                    if (data.title === 'OK') {
                        onResetForm()
                        executeFetchAllCreditPayments()
                        closeModal()
                    }

                })
                .catch(error => {
                    console.log('API ERROR: ', error)
                })

        }

        if (formState.movimiento_tipo === 'DEPOSITO') {

            if (formState.acceptedFiles.length <= 0) {

                const messageCustom = {
                    message: 'Debe cargar el comprobante para poder registrar el deposito',
                    title: 'FAIL',
                    rows: []
                }

                alertMessage(messageCustom)

                return
            }

            const _data = new FormData();

            _data.append('idpago', formStateGlobal.idpago)
            _data.append('idbanco', formState.idbanco)
            _data.append('idcredito', idcredito)
            _data.append('movimiento_tipo', formState.movimiento_tipo)
            _data.append('deposito_fecha', formState.deposito_fecha)
            _data.append('deposito_usuario', user.username)
            _data.append('deposito_monto', formState.deposito_monto)
            _data.append('deposito_moneda', formState.deposito_moneda)
            _data.append('deposito_tipo_cambio', formState.deposito_tipo_cambio)
            _data.append('deposito_quetzal', formState.deposito_quetzales)
            _data.append('deposito_dolares', formState.deposito_dolares)
            _data.append('boleta_numero', formState.boleta_numero)
            _data.append('usuario_creo', user.username)
            _data.append('fecha_creo', getCurrentDate())

            formState.acceptedFiles.forEach((file, index) => {
                _data.append(`images`, file);
            });

            await marvarApi.post(`/vehicle/mgmt-payments/create-deposit-bank`, _data)
                .then(({ data }) => {
                    alertMessage(data)

                    if (data.title === 'OK') {
                        // executeFetchAllDeposits()
                        onResetForm()
                        closeModal()

                    }

                })
                .catch(error => {
                    console.log('API ERROR: ', error)
                })

        }
    }

    const handleClickFetchInfoDeposit = async (idmovimiento) => {

        const { FormDeposit: { onResetForm, formState: { idpago } } } = Forms
        const { setModalOpeningMode } = globalStates

        const { fetchInfoDeposit } = FetchData
        const { setParamsToSearch, executeFetchInfoDeposit } = fetchInfoDeposit

        // Reseteamos el formulario para limpiar cualquier rastro de una busqueda anterior
        onResetForm()

        // Seteamos los parametros para filtrar info y ejecutamos el fetch
        setParamsToSearch({ idmovimiento: idmovimiento })
        await executeFetchInfoDeposit()

        setModalOpeningMode('READONLY')

        setDataModal(prevState => ({
            ...prevState,
            titleModal: 'Deposito',
            componentModal: 'deposits-section',
        }))
        // handleClickShowModal('', 'Formulario de depositos', 'deposits-section', {idpago}, 'READONLY')

    }


    const handleClickReturnModal = async (idmovimiento) => {

        const { FormDeposit: { onResetForm } } = Forms


        // Reseteamos el formulario para limpiar cualquier rastro de una busqueda anterior
        onResetForm()

        setDataModal(prevState => ({
            ...prevState,
            titleModal: 'Tabla de Depositos',
            componentModal: 'deposits-table',
        }))

    }

    const handleChangeCredit = async (value) => {

        const { FormRequestGlobal: { setFormState, onSelectSearchChange } } = Forms
        const { fetchAllCreditsPayments: { setParamsToSearch, executeFetchAllCreditPayments } } = FetchData


        onSelectSearchChange({ target: { name: 'idcredito', value: value.value } })
        setParamsToSearch({ idcredito: value.value })
        setFormState(prevState => ({
            ...prevState,
            'idcredito': value.value
        }))
        executeFetchAllCreditPayments()

    }

    const handleClickSearchPendientes = async () => {
        const { fetchAllCreditsPayments: { setParamsToSearch, executeFetchAllCreditPayments } } = FetchData

        // onResetForm()
        setParamsToSearch({ pendiente: true })
        executeFetchAllCreditPayments()
    }

    const handleClickUpdateAprobacion = async (e) => {

        e.preventDefault()
        const { getCurrentDate } = Helpers

        const { FormDeposit: { formState } } = Forms

        if (['APROBADO', 'RECHAZADO', 'REVERTIDO'].includes(formState.aprobacion_check_original)) {
            return
        }

        const aprobacionCheck = String(formState.aprobacion_check ?? '').trim().toUpperCase()
        if (!['APROBADO', 'RECHAZADO'].includes(aprobacionCheck)) {
            toast.warn('Solo se permite guardar con estado APROBADO o RECHAZADO', {
                position: 'top-right',
                theme: 'colored',
                autoClose: false,
            })
            return
        }

        const { fetchAllDeposits: { executeFetchAllDeposits }, fetchAllCreditsPayments: { executeFetchAllCreditPayments } } = FetchData

        const body = {
            aprobacion_check: aprobacionCheck,
            aprobacion_referencia_ach: formState.aprobacion_referencia_ach,
            aprobacion_observaciones: formState.aprobacion_observaciones,
            aprobacion_usuario: user.username,
            aprobacion_fecha: getCurrentDate()
        }

        await marvarApi.put(`/credits/admin-managements/aprobacion-check-payment/${formState.idmovimiento}`, body).then(({ data }) => {
            alertMessage(data)
            if (data.title === 'OK') {
                executeFetchAllDeposits()
                executeFetchAllCreditPayments()
                handleClickCloseModal()
            }
        })
            .catch(error => {
                console.log('API ERROR: ', error)
            })
    }


    return Object.freeze({
        handleClickSearchPayments,
        handleKeyDown,
        handleClickShowModal,
        handleClickCloseModal,
        handleChangeAmount,
        handleChangeTypeCurrency,
        handleChangeExchangeRate,
        handleClickDownloadImage,
        onSubmitFormDeposits,
        handleClickFetchInfoDeposit,
        handleClickReturnModal,
        handleClickFechtVehicleCredits,
        handleChangeCredit,
        handleClickSearchPendientes,
        handleClickUpdateAprobacion,
    })
}

/**
 * Funcion para gestionar las alertas de toastify
 * @param {*} res : respuesta del API / custom (debe ser un json "{}")
 * @param {*} toggle : toggle de modal
 */
const alertMessage = (res, toggle) => {

    if (res) {
        const { title, message } = res
        if (title === 'OK') {
            toast.success(message, {
                position: "top-right",
                theme: "colored"
            })
            toggle && toggle()
        } else {
            toast.warn(message, {
                position: "top-right",
                theme: "colored",
                autoClose: false,
            })
        }
    } else {
        toast.warn('Error interno, notifique a Soporte técnico!.', {
            position: "top-right",
            theme: "colored",
            autoClose: false,
        })
    }
}